import React, { useCallback, useEffect, useMemo, useState } from 'react'
import Cargando from '../../Varios/Cargando';

import { UserData } from 'components/Sidebar/Sidebar_Principal';
import { authenticationService } from 'services/authentication.service';
import { GetDocumentVistaPrevia } from 'helpers/files';
import ModalVistaPreviaDocumentos from 'components/Varios/Modals/ModalVistaPreviaDocumentos';

import { ROL_DIRECTOR_TALENTOHUMANO, ROL_NOMINA_TH } from 'Context/SideBarContext';

import { Container, Table, Row, Col, Label, Input, Button } from 'reactstrap'
import { ObtenerFechaFromIsoFormat } from 'functions/DatesFunctions';
import ModalRechazo from 'components/DirectivoUnidad/AprobacionSolicitudes/ModalRechazoSolicitud';
import { alertService } from 'components/Varios/alert_service';
import { ScrollToTop } from 'functions/LayoutFunctionst';
import ModalConfirmacion from 'components/Varios/Modals/ModalConfirmacion';
import { ResponseRequest } from 'components/Types/GeneralTypes';
import ModalVistaPreviaDocumentosAccion from 'components/Varios/Modals/ModalVistaPreviaDocumento';
import { AnularAccionPersonalLicencia, FirmaMasivaAccionPersonal, FirmarAPSolicitudLicencias, ObtenerInformacionSolicitudesFirma, VistaPreviaSolicitudLicencias } from './FunctionsFirmaNomina';
import { SolicitudesFirmaAPTH } from './TypesFirmaAPNomina';
import TablaFirmarAPSolicitudes from './TablaFirmaAPSolicitudes';

import Swal from 'sweetalert2';

import ExitoSVG from "./../../../assets/icons/Permisos/Exitosa.svg"
import ErrorSVG from "./../../../assets/icons/Permisos/Error.svg"

type StateAprobacionSolicitudes = {
    filasTabla: SolicitudesFirmaAPTH[],
    loadingFilas: boolean,
    errorFilas: boolean,
    mensajeAprobacion: string | undefined,
    mensajeError: string | undefined,
}

type StateModalVistaPrevia = {
    loading: boolean,
    url: string
}

type StateModalInformacionFirmarAP = {
    url: string,
    cargando: boolean,
    idSolicitud: number,
    modalContent: HTMLElement | undefined,
    tituloModal: string
}

type StateModalInformacionRechazar = {
    cargando: boolean,
    idSolicitud: number,
    modalContent: HTMLElement | undefined,
    observacion: string
}

type StateModalAprobacionMasicaAccionPersonal = {
    cargando: boolean,
    modalContent: HTMLElement | undefined,
    filasTabla: SolicitudesFirmaAPTH[],
}

export default function FirmaAPNomina() {
    const TITULO_APROBACION_SOLICITUDES_NOMINA = "FIRMA DE AP DE LICENCIAS COMO RESPONSABLE DE TH";
    const TITULO_APROBACION_SOLICITUDES_DELEGADO = "FIRMA DE AP DE LICENCIAS COMO DELEGADO DE LA AUTORIDAD NOMINADORA";

    const datosUsuario: UserData = authenticationService.currentUserValue;

    // Asumiendo que los roles se almacenan en un arreglo en datosUsuario.roles_usuario
    const tituloAprobacion = datosUsuario.roles_usuario.includes(ROL_DIRECTOR_TALENTOHUMANO)
        ? TITULO_APROBACION_SOLICITUDES_DELEGADO
        : datosUsuario.roles_usuario.includes(ROL_NOMINA_TH)
            ? TITULO_APROBACION_SOLICITUDES_NOMINA
            : "FIRMA DE ACCIÓN DE PERSONAL DE SOLICITUDES DE LICENCIAS"; // Opcional, en caso de que no se cumpla ninguna condición


    const defaulState: StateAprobacionSolicitudes = {
        filasTabla: [],
        loadingFilas: false,
        errorFilas: false,
        mensajeAprobacion: undefined,
        mensajeError: undefined,
    }

    const defaultStateModalVistaPrevia: StateModalVistaPrevia = {
        loading: false,
        url: ""
    }

    const defaultStateModalInformacionFirmarAP: StateModalInformacionFirmarAP = {
        url: "",
        cargando: false,
        idSolicitud: -1,
        modalContent: undefined,
        tituloModal: "Firma de Acción de Personal de Licencias"
    }

    const defaultSateModalAprobacionMasivaAccionPersonal: StateModalAprobacionMasicaAccionPersonal = {
        cargando: false,
        modalContent: undefined,
        filasTabla: [],
    }

    const defaultStateModalInformacionAnular: StateModalInformacionRechazar = {
        cargando: false,
        idSolicitud: -1,
        modalContent: undefined,
        observacion: ""
    }

    const [stateAprobacion, setstateAprobacion] = useState<StateAprobacionSolicitudes>(defaulState)
    const [stateModalVP, setstateModalVP] = useState<StateModalVistaPrevia>(defaultStateModalVistaPrevia)


    const [stateinformacionModalFirmarAP, setstateinformacionModalFirmarAP] = useState(defaultStateModalInformacionFirmarAP)

    const [stateModalAprobacionMasivaAccionPersonal, setstateModalAprobacionMasivaAccionPersonal] = useState(defaultSateModalAprobacionMasivaAccionPersonal)
    const [stateinformacionModalAnular, setstateinformacionModalAnular] = useState(defaultStateModalInformacionAnular)


    const [observacion, setobservacion] = useState("")

    async function showAlert(message, imageSrc, isSuccess) {
        Swal.fire({
            text: message,
            imageUrl: `${imageSrc}`,
            imageHeight: 100,
            imageAlt: isSuccess ? "Éxito" : "Error",
            confirmButtonText: "Entendido",
            confirmButtonColor: "#243165",
        });
    }

    async function ObtenerDatosSolicitudes() {
        setstateAprobacion({ ...stateAprobacion, loadingFilas: true })
        const resultado = await ObtenerInformacionSolicitudesFirma()
        if (resultado.status === 200) {
            if (typeof (resultado.dataResponse) === "string") {
                setstateAprobacion({ ...stateAprobacion, mensajeAprobacion: resultado.dataResponse, loadingFilas: false })
            }
            else {
                setstateAprobacion({ ...stateAprobacion, filasTabla: resultado.dataResponse, loadingFilas: false })
            }

        } else {
            setstateAprobacion(prev => ({ ...prev, mensajeError: "Usted no está autorizado para realizar las validaciones de estas solicitudes", loadingFilas: false, errorFilas: true }));

        }
        
    }

    const onClickVerDoc = useCallback(
        async (referencia: string) => {
            setstateModalVP({ ...stateModalVP, loading: true })
            const datosUsuario: UserData = authenticationService.currentUserValue;
            const url = await GetDocumentVistaPrevia(referencia, datosUsuario.token);
            setstateModalVP({ ...stateModalVP, loading: false, url })
        }, [stateModalVP])


    useEffect(() => {
        ObtenerDatosSolicitudes();
    }, [])



    async function OnCloseModalFirma() {
        await ObtenerDatosSolicitudes()
        setstateinformacionModalFirmarAP(defaultStateModalInformacionFirmarAP)
        ScrollToTop();

    }

    async function OnCloseModalAnulacion() {
        await ObtenerDatosSolicitudes()
        setstateinformacionModalAnular(defaultStateModalInformacionAnular)
        ScrollToTop();
    }

    function AuxiliarGenerarHTMLBodyModalPermisos(informacionAcciones): any {
        return(
                <>
                <Table bordered className="tableHistorialSolicitudesVacaciones" responsive>
                    <thead className="cabecerasDetallehistorialSolic">
                        <tr className="" >
                            <th> Fecha Solicitud</th>
                            <th> Nombre</th>
                            <th> Fecha Desde</th>
                            <th> Fecha Hasta</th>
                            <th> Días </th>
                            <th> Estado Solicitud</th>
                        </tr>
                    </thead>
                    <tbody>

                        {informacionAcciones.map((solicitudes, ind) => {
                            
                            return (
                                <tr key={"trMasivoSolicVac" + ind} className="rowHistorialSolicitudVacaciones">
                                    <td className="">
                                        <div className="">
                                            {ObtenerFechaFromIsoFormat(solicitudes.fechaSolicitud)}
                                        </div>
                                    </td>
                                    <td className="">
                                        <div className="">
                                            {solicitudes.nombres}
                                        </div>
                                    </td>
                                    <td className="">
                                        <div className="">
                                            {ObtenerFechaFromIsoFormat(solicitudes.fechaInicio)}
                                        </div>
                                    </td>
                                    <td className="">
                                        <div className="">
                                            {ObtenerFechaFromIsoFormat(solicitudes.fechaFin)}
                                        </div>
                                    </td>
                                    <td className="">
                                        <div className="">
                                            {solicitudes.tiempo}
                                        </div>
                                    </td>
                                    <td className="">
                                        <div className="">
                                            {solicitudes.estadoParse}
                                        </div>
                                    </td>
                                </tr>
                            )
                        })}

                    </tbody>
                </Table>
                </>
        )
    }

    function onClickAprobacionMasiva(informacionAcciones) {

        const modalContent = AuxiliarGenerarHTMLBodyModalPermisos(informacionAcciones)
        setstateModalAprobacionMasivaAccionPersonal({
            cargando: false,
            filasTabla: informacionAcciones,
            modalContent
        })
    }

    function AuxiliarGenerarHTMLBodyModalAnular(informacionAcciones): any {
        return(
                <>

                <Table bordered className="tableHistorialSolicitudesVacaciones" responsive>
                    <thead className="cabecerasDetallehistorialSolic">
                        <tr className="" >
                            <th> Fecha Solicitud</th>
                            <th> Nombre</th>
                            <th> Fecha Desde</th>
                            <th> Fecha Hasta</th>
                            <th> Días </th>
                            <th> Estado Solicitud</th>
                        </tr>
                    </thead>
                    <tbody>

                        <tr className="rowHistorialSolicitudVacaciones">
                            <td className="">
                                <div className="">
                                    {ObtenerFechaFromIsoFormat(informacionAcciones.fechaSolicitud)}
                                </div>

                            </td>
                            <td className="">
                                <div className="">
                                    {informacionAcciones.nombres}
                                </div>

                            </td>
                            <td className="">
                                <div className="">
                                    {ObtenerFechaFromIsoFormat(informacionAcciones.fechaInicio)}
                                </div>

                            </td>
                            <td className="">
                                <div className="">
                                    {ObtenerFechaFromIsoFormat(informacionAcciones.fechaFin)}
                                </div>

                            </td>
                            <td className="">
                                <div className="">
                                    {informacionAcciones.tiempo}
                                </div>
                            </td>
                            <td className="">
                                <div className="">
                                    {informacionAcciones.estadoParse}
                                </div>

                            </td>

                        </tr>

                    </tbody>
                </Table>
                </>
        )
    }

    function onClickAnularAccionPersonal(informacionAcciones) {

        const modalContent = AuxiliarGenerarHTMLBodyModalAnular(informacionAcciones);

        setstateinformacionModalAnular({
            cargando: false,
            idSolicitud: informacionAcciones.idPermiso,
            modalContent,
            observacion
        })
    }

    async function AnularAP(idSolicitud, observacion) {
        const respuesta = await AnularAccionPersonalLicencia(idSolicitud, observacion)
        if (respuesta.status !== 200) {
            //alertService.error(respuesta.errorMessage)
            await showAlert(respuesta.errorMessage, ErrorSVG, false);
            return 1;
        }
        else {
            //alertService.success("Se ha anulado la acción de personal");
            await showAlert("Se ha anulado la acción de personal", ExitoSVG, true);
            return -1

        }
    }



    const tablaSolicitudes = useMemo(() => {
        const { loadingFilas, errorFilas, filasTabla , mensajeError} = stateAprobacion
        if (loadingFilas) {
            return <Cargando mensaje='Cargando Solicitudes' />;
        }
        else if (!loadingFilas && errorFilas && mensajeError === undefined) {
            return <div>No ha sido posible cargar la información</div>
        }else if (!loadingFilas && errorFilas && mensajeError) {
            return <div className="alert alert-danger">{mensajeError}</div>;
        }
        else if (filasTabla.length > 0) {
            return (
                <TablaFirmarAPSolicitudes 
                    dataFilas={stateAprobacion.filasTabla}
                    onClickVerDocumento={async (referencia: string) => await onClickVerDoc(referencia)}
                    onClickFirmarLicencia={async(solicitud: any) => await onClickVistaPreviaFirmarSolicitudesLicencias(solicitud)}
                    onClickAprobacionMasiva={async(solicitudes: SolicitudesFirmaAPTH[]) => await onClickAprobacionMasiva(solicitudes)}
                    onClickRechazar = {(solicitud: any) => onClickAnularAccionPersonal(solicitud)}
                />
                
            )

        }
        else {
            return (
                <TablaFirmarAPSolicitudes
                    dataFilas={[]}
                    onClickVerDocumento={async (referencia: string) => {;}}
                    onClickFirmarLicencia={async(solicitud: any) => {;}}
                    onClickAprobacionMasiva={async(solicitudes: SolicitudesFirmaAPTH[]) => {;}}
                    onClickRechazar = {(solicitud: any) => {;}}
                />
            )
        }

    }, [stateAprobacion])

    
    

    async function OnClickAccionModalFormulario(idSolicitud) {
        setstateinformacionModalFirmarAP({ ...defaultStateModalInformacionFirmarAP, cargando: true })
        var accionRealizada = await FirmarAPSolicitudLicencias(idSolicitud)
        setstateinformacionModalFirmarAP(defaultStateModalInformacionFirmarAP)
        setstateModalAprobacionMasivaAccionPersonal(defaultSateModalAprobacionMasivaAccionPersonal)
        await ObtenerDatosSolicitudes();
    }

    async function OnCloseModalAprobacionMasiva() {
        setstateModalAprobacionMasivaAccionPersonal(defaultSateModalAprobacionMasivaAccionPersonal)
        await ObtenerDatosSolicitudes();
    }
    
    async function onClickVistaPreviaFirmarSolicitudesLicencias(informacionAcciones) {
        var titulo = "";
        var respuestaSolicitud: ResponseRequest = { status: -1 };
        respuestaSolicitud = await VistaPreviaSolicitudLicencias(informacionAcciones.idPermiso);
        if (respuestaSolicitud.status === 200) {
            var content: any = undefined;
            titulo = "Acción de Personal de Licencia"
            setstateinformacionModalFirmarAP({ 
                url: respuestaSolicitud.dataResponse, 
                cargando: false, 
                tituloModal: titulo, 
                modalContent: content, 
                idSolicitud:informacionAcciones.idPermiso  
            })
        }
        else {
            //alertService.error(respuestaSolicitud.errorMessage ?? "");
            await showAlert(respuestaSolicitud.errorMessage ?? "", ErrorSVG, false);
            
        }
    }

    return (
        
        <div className="content">
            <div className="titulo_seccion mb-5"> {tituloAprobacion} </div>
            {tablaSolicitudes}
            <ModalVistaPreviaDocumentosAccion
                show={stateinformacionModalFirmarAP.url !== "" || stateinformacionModalFirmarAP.cargando}
                onClose={() => setstateinformacionModalFirmarAP(defaultStateModalInformacionFirmarAP)}
                accionOnAccept={true}
                cargandoDatos={stateinformacionModalFirmarAP.cargando}
                size="xl"
                tituloModal={stateinformacionModalFirmarAP.tituloModal}
                urlArchivo={stateinformacionModalFirmarAP.url}
                asyncAccion={() => OnClickAccionModalFormulario(stateinformacionModalFirmarAP.idSolicitud)}
                disabledbuttonCondition={stateinformacionModalFirmarAP.cargando}
                modalContent={stateinformacionModalFirmarAP.modalContent}
            />
            <ModalVistaPreviaDocumentos
                cargandoDatos={stateModalVP.loading}
                onClose={() => setstateModalVP(defaultStateModalVistaPrevia)}
                show={stateModalVP.loading || stateModalVP.url !== ""}
                size="xl"
                tituloModal='Documento de permisos y/o licencias'
                urlArchivo={stateModalVP.url}
                botonCerrar={true}
            />

            <ModalConfirmacion
                show={stateModalAprobacionMasivaAccionPersonal.filasTabla.length > 0}
                size="lg"
                onClose={() => setstateModalAprobacionMasivaAccionPersonal(defaultSateModalAprobacionMasivaAccionPersonal)}
                asyncAccion={true}
                asyncClose={true}
                closeAfterAccion={true}
                hideBotonCerrar={false}
                mensajeConfirmacion={"¿Está seguro/a que desea firmar las siguientes Acciones de Personal?"}
                nombreBotonAccion={"SI"}
                nombreBotonCerrarModal={"NO"}
                asyncOnClick={() => FirmaMasivaAccionPersonal(stateModalAprobacionMasivaAccionPersonal.filasTabla)}
                contentModal={stateModalAprobacionMasivaAccionPersonal.modalContent}
                tituloModal={"Firma masiva de Acción de Personal"}
                asyncAfterOnClose={() => OnCloseModalAprobacionMasiva()}
                botonesAccionParteSuperior={true}

            />

            <ModalRechazo
                show={stateinformacionModalAnular.idSolicitud > 0 || stateinformacionModalAnular.cargando}
                size="lg"
                onClose={() => setstateinformacionModalAnular(defaultStateModalInformacionAnular)}
                asyncAccion={true}
                asyncClose={true}
                closeAfterAccion={true}
                hideBotonCerrar={false}
                mensajeConfirmacion={"¿Está seguro/a que desea anular la acción de personal?"}
                nombreBotonAccion={"SI"}
                nombreBotonCerrarModal={"NO"}
                asyncOnClick={(observacion) => AnularAP(stateinformacionModalAnular.idSolicitud, { Observacion: observacion })}
                contentModal={stateinformacionModalAnular.modalContent}
                tituloModal={"Anular Acción de Personal"}
                asyncAfterOnClose={() => OnCloseModalAnulacion()}
                labelObservacion={"Indique el motivo de anulación"}
                botonesAccionParteSuperior={true}
                classNamemensajeConfirmacion={"mensajeModalsSolicitudVacaciones"}
                maxLength={500}

            />
        </div>
    )

}